import { render, staticRenderFns } from "./AddNonConformity.vue?vue&type=template&id=12945446&scoped=true&"
import script from "./AddNonConformity.vue?vue&type=script&lang=js&"
export * from "./AddNonConformity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12945446",
  null
  
)

export default component.exports